var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('router-link',{attrs:{"to":_vm.route},nativeOn:{"click":function($event){return _vm.handleClick($event)}}},[_vm._v(" "+_vm._s(_vm.buttonName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }